import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";
import { createFocusTrap } from "focus-trap";

// Connects to data-controller="frontend--nav"
export default class extends Controller {
  static targets = ["nav", "toggle"];
  focusTrap = null;
  mediaQuery = window.matchMedia("(min-width: 75em)");

  connect = () => {
    useClickOutside(this, { element: this.navTarget });

    this.toggleTarget.addEventListener("click", () => {
      const isOpen = this.toggleTarget.getAttribute("aria-expanded") === "true";
      this.toggleTarget.setAttribute(
        "aria-expanded",
        isOpen ? "false" : "true",
      );
      if (!isOpen) {
        this.activateFocusTrap();
      } else {
        this.deactivateFocusTrap();
      }
    });

    document.addEventListener("keydown", this.handleEsc);

    this.mediaQuery.addEventListener("change", this.handleMediaQuery);
  };

  disconnect = () => {
    document.removeEventListener("keydown", this.handleEsc);
    this.mediaQuery.removeEventListener("change", this.handleMediaQuery);
    this.deactivateFocusTrap();
  };

  handleEsc = (event) => {
    if (
      event.key === "Escape" &&
      this.toggleTarget.getAttribute("aria-expanded") === "true"
    ) {
      this.closeNav();
    }
  };

  handleMediaQuery = (event) => {
    if (event.matches) {
      this.closeNav();
    }
  };

  clickOutside = () => {
    this.closeNav();
  };

  activateFocusTrap = () => {
    if (!this.focusTrap) {
      this.focusTrap = createFocusTrap(this.navTarget, {
        clickOutsideDeactivates: false,
        onDeactivate: this.closeNav,
      });
    }
    this.focusTrap.activate();
  };

  deactivateFocusTrap = () => {
    if (this.focusTrap) {
      this.focusTrap.deactivate();
    }
  };

  closeNav = () => {
    this.toggleTarget.setAttribute("aria-expanded", "false");
    this.deactivateFocusTrap();
  };
}
